import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import Box from '@cloudscape-design/components/box';
import Header from '@cloudscape-design/components/header';
import Link from '@cloudscape-design/components/link';
import Table from '@cloudscape-design/components/table';
import { formatInt } from '@/features/dashboard-finance/formatters';
import type { TopTenantRow } from './useUsage';

/** Tabela das 20 contas que mais imprimiram no período, com link para o detalhe do tenant. */
export function TopTenantsTable({ rows }: { rows: readonly TopTenantRow[] }): React.JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Table<TopTenantRow>
      items={[...rows]}
      trackBy="tenantId"
      variant="container"
      header={<Header variant="h3">{t('usage.top.title', { count: rows.length })}</Header>}
      empty={<Box textAlign="center" color="inherit">{t('usage.empty')}</Box>}
      columnDefinitions={[
        {
          id: 'tenant',
          header: t('usage.top.tenant'),
          cell: (r): React.ReactNode => (
            <Link
              href={`/tenants/${r.tenantId}`}
              onFollow={(e): void => {
                e.preventDefault();
                void navigate(`/tenants/${r.tenantId}`);
              }}
            >
              {r.tenantName}
            </Link>
          ),
        },
        { id: 'country', header: t('usage.top.country'), cell: (r): React.ReactNode => r.countryCode },
        {
          id: 'labels',
          header: t('usage.top.labels'),
          cell: (r): React.ReactNode => formatInt(r.totalLabels),
        },
      ]}
    />
  );
}
